import client from './client';
import type { Namespace, NamespaceActionResponse } from '@/types';

export async function fetchNamespaces(includeProtected = false) {
  const { data } = await client.get<Namespace[]>('/namespaces', {
    params: includeProtected ? { include_protected: true } : undefined,
  });
  return data;
}

export async function fetchNamespace(namespace: string) {
  const { data } = await client.get<Namespace>(`/namespaces/${namespace}`);
  return data;
}

export async function stopNamespace(namespace: string) {
  const { data } = await client.post<NamespaceActionResponse>(`/namespaces/${namespace}/stop`);
  return data;
}

export async function startNamespace(namespace: string) {
  const { data } = await client.post<NamespaceActionResponse>(`/namespaces/${namespace}/start`);
  return data;
}
